<ng-template #userMenuDialog>
<div class="modal">
    <form novalidate [formGroup]="menuForm" style="margin: 0px;">
        <div class="modal-content" style="padding: 5px; margin: 0px;">
            <div class="row" style="margin: 0px;">
                    <div class="row" style="margin: 0px; position: relative;" *ngIf="resendVisible">
                        <button type="button" mat-button (click)="resend()" class="user-options-menu-button" style="text-transform: none;">Password Reset Email</button>
                    </div>
                    <div class="row" style="margin: 0px; position: relative;" *ngIf="extendVisible">
                        <button type="button" mat-button (click)="extend()" class="user-options-menu-button" style="text-transform: none;">Extend Validity</button>
                    </div>
            </div>
        </div>
    </form> 
</div>
</ng-template>